import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "./Trust.css";
import trust1 from "../assets/trust1.png";
import trust2 from "../assets/trust2.png";
import trust3 from "../assets/trust3.png";
import trust4 from "../assets/trust4.png";

export default function Trust() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth <= 840);
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const trustCards = [
    {
      img: trust1,
      title: "Production-Ready ML Models",
      desc: "Every model is designed for real-world use—optimized for speed, accuracy, and stability so your business gets consistent, reliable outcomes, not just experimental results.",
    },
    {
      img: trust2,
      title: "Data-Driven Strategy & Implementation",
      desc: "We don’t just build models—we structure your data pipeline, refine inputs, and ensure your ML system is aligned with actual business goals for maximum measurable impact.",
    },
    {
      img: trust3,
      title: "End-to-End MLOps & Lifecycle Management",
      desc: "From versioning to monitoring, updates, and retraining, we maintain your ML system throughout its lifecycle, keeping performance strong as your data and business evolve.",
    },
    {
      img: trust4,
      title: "Enterprise Security & Compliance First",
      desc: "Your data stays protected with strict access control, encryption, secure cloud deployment, and compliance-driven workflows designed to meet enterprise-grade security standards.",
    },
  ];

  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div id="trust" className="machinemainclass">
      <h2 className="heading">
       Our Core Strengths in AI and ML
      </h2>

      <p className="subheading">
     We combine deep technical expertise with real industry experience to deliver machine learning solutions that are accurate, scalable, and built to handle real-world business challenges without compromising performance or reliability.
      </p>

      <div className="cards">
        {isMobile ? (
          <Slider {...sliderSettings}>
            {trustCards.map((card, index) => (
              <div className="card" key={index}>
                <div className="left">
                  <img src={card.img} alt={card.title} />
                </div>
                <div className="right">
                  <h3>{card.title}</h3>
                  <span>{card.desc}</span>
                </div>
              </div>
            ))}
          </Slider>
        ) : (
          trustCards.map((card, index) => (
            <div className="card" key={index}>
              <div className="left">
                <img src={card.img} alt={card.title} />
              </div>
              <div className="right">
                <h3>{card.title}</h3>
                <span>{card.desc}</span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
